import { BugoBrandBrief } from '@shared/api/bugoBrand/bugoBrand.interface';

/**
 * 상조(부고브랜드) 표기명.
 * 멀티 브랜드를 쓰는 상조는 fevent.bugoBrandAgencyIndex가 가리키는 bugoAgencyList 항목이 실제 표기명이다.
 * populate 안된(문자열 id) 경우엔 빈 문자열.
 */
export const getAgencyBrandName = (
  bugoBrand?: BugoBrandBrief | string | null,
  bugoBrandAgencyIndex?: number,
): string => {
  if (!bugoBrand || typeof bugoBrand === 'string') return '';
  const multiAgency =
    typeof bugoBrandAgencyIndex === 'number'
      ? bugoBrand.bugoAgencyList?.[bugoBrandAgencyIndex]
      : undefined;
  return (
    multiAgency?.nickName ??
    multiAgency?.corpName ??
    bugoBrand.bugoAgency?.nickName ??
    bugoBrand.bugoAgency?.corpName ??
    ''
  );
};
